import React from 'react';
import { useIntl } from 'react-intl';
import { Box, ListItem } from '@mui/material';
import PropTypes from 'prop-types';

import { ReactComponent as EditArrow } from 'assets/icons/arrow-right-profile.svg';
import Link from 'components/link/Link';

const ProfileConstructor = (props) => {
    const { ariaLabel, children, routeId } = props;
    const { formatMessage } = useIntl();

    return (
        <ListItem className="settings-item-container" divider={!ariaLabel.includes('password')}>
            <Box className="item">{children}</Box>
            <Link className="edit-button" id={ariaLabel} title={formatMessage({ id: ariaLabel })} to={routeId}>
                <EditArrow aria-label={formatMessage({ id: ariaLabel })} className="edit-icon" />
            </Link>
        </ListItem>
    );
};

ProfileConstructor.propTypes = {
    ariaLabel: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    routeId: PropTypes.string.isRequired,
};

export default ProfileConstructor;
